import style from './PareadBox.module.css'
import React, { useEffect, useState } from 'react'

function InputesDiv({
    isInterNalSensor = false,
    ele,
    internalInputs,
    setInternalInputs,

    PABytesToSensorDataFunRef,
    receivedPABytes,
    stopPAread,

    externalInputs,
    setExternalInputs,
}) {
    const [selected, setSelected] = useState(false)
    const [mode, setMode] = useState('Digital') // default Digital
    const handleToggle = () => {
        if (!selected) return // disabled if not selected
        setMode(mode === 'Digital' ? 'Analog' : 'Digital')
    }
    // const [sensorValue, setSensorValue]=useSate
    //handel click the input button image
    const handelInputBtnImg = (ele) => {
        let newInternalInputs = JSON.parse(JSON.stringify(internalInputs))

        newInternalInputs[ele.id].isActive = !newInternalInputs[ele.id].isActive
        if (ele.label === 'Light Sensor') {
            newInternalInputs[8].isActive = false
            newInternalInputs[9].isActive = false
            newInternalInputs[10].isActive = false
            newInternalInputs[6].isActive = false
            newInternalInputs[7].isActive = false
        } else if (ele.label === 'Gesture Sensor') {
            newInternalInputs[8].isActive = false
            newInternalInputs[9].isActive = false
            newInternalInputs[10].isActive = false
            newInternalInputs[6].isActive = false
            newInternalInputs[11].isActive = false
        } else if (ele.label === 'Distance Sensor') {
            newInternalInputs[8].isActive = false
            newInternalInputs[9].isActive = false
            newInternalInputs[10].isActive = false
            newInternalInputs[11].isActive = false
            newInternalInputs[7].isActive = false
        } else if (
            ['Color Red', 'Color Green', 'Color Blue'].includes(ele.label)
        ) {
            newInternalInputs[11].isActive = false
            newInternalInputs[6].isActive = false
            newInternalInputs[7].isActive = false
        }

        setInternalInputs(newInternalInputs)
        stopPAread()
    }

    //handel click on the port circular button click
    const handelPortBtnClick = (ele) => {
        if (!ele.isDisable) {
            return
        }

        const newExternalInputs = JSON.parse(JSON.stringify(externalInputs))
        newExternalInputs[ele.id].isActive = !newExternalInputs[ele.id].isActive
        setExternalInputs(newExternalInputs)
        stopPAread()
    }

    // handel click on swipe button click for each poart
    const handelSwipeBtnClick = (ele) => {
        const newExternalInputs = JSON.parse(JSON.stringify(externalInputs))
        newExternalInputs[ele.id].isAnalog = !newExternalInputs[ele.id].isAnalog
        setExternalInputs(newExternalInputs)
        stopPAread()
    }

    const getSensorData = () => {
        if (PABytesToSensorDataFunRef) {
            return (
                PABytesToSensorDataFunRef(
                    receivedPABytes,
                    isInterNalSensor ? 'internal' : 'external',
                    ele.id
                ) ?? ''
            )
        }
    }

    // The Red/Green/Blue color sensor tiles all share the same icon, so a
    // letter badge is needed to tell them apart at a glance.
    const colorChannel =
        ele.label === 'Color Red'
            ? 'R'
            : ele.label === 'Color Green'
                ? 'G'
                : ele.label === 'Color Blue'
                    ? 'B'
                    : null
    const colorChannelBg =
        colorChannel === 'R'
            ? '#e53935'
            : colorChannel === 'G'
                ? '#43a047'
                : '#1e88e5'

    return (
        <>
            {isInterNalSensor ? (
                <div className={style.inputContainer} key={ele.id}>
                    <div className={style.imgWrapper}>
                        <img
                            src={
                                internalInputs[ele.id].isActive
                                    ? ele.activeImage
                                    : ele.inactiveImage
                            }
                            alt={ele.label}
                            className={style.inputBtnImg}
                            onClick={() => handelInputBtnImg(ele)}
                        />
                        {colorChannel && (
                            <span
                                className={style.colorBadge}
                                style={{ background: colorChannelBg }}
                            >
                                {colorChannel}
                            </span>
                        )}
                    </div>

                    <p className={style.inputLabel}>
                        {internalInputs[ele.id].isActive ? getSensorData() : ''}
                    </p>
                </div>
            ) : (
                <div className={style.inputContainer} key={ele.id}>
                    <div className={style.pin_container}>
                        {/* Circle Button */}
                        <button
                            className={`${style.circle_btn} ${
                                externalInputs[ele.id].isActive
                                    ? style.selected
                                    : ''
                            }`}
                            onClick={() => handelPortBtnClick(ele)}
                        >
                            {ele.sort_label}
                        </button>

                        {/* Toggle Switch */}
                        <div
                            className={`${style.toggle} ${
                                !externalInputs[ele.id].isActive
                                    ? style.disabled
                                    : ''
                            }`}
                            onClick={() => handelSwipeBtnClick(ele)}
                        >
                            <div
                                className={`${style.option} ${
                                    !externalInputs[ele.id].isAnalog
                                        ? style.active
                                        : ''
                                }`}
                            >
                                Digital
                            </div>
                            <div
                                className={`${style.option} ${
                                    externalInputs[ele.id].isAnalog
                                        ? style.active
                                        : ''
                                }`}
                            >
                                Analog
                            </div>
                            <div
                                className={`${style.slider} ${
                                    externalInputs[ele.id].isAnalog
                                        ? style.analog
                                        : style.digital
                                }`}
                            />
                        </div>
                    </div>

                    <p className={style.inputLabel}>
                        {ele.isActive ? getSensorData() : ''}
                    </p>
                </div>
            )}
        </>
    )
}

export default InputesDiv
